module.exports = __webpack_public_path__ + "35aa649c6b0a9715bf8b67fb09cc85b2.png";